// Dependencies
import { styled } from "@mui/material/styles";

// Components
import { Card } from "@mui/material";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "PasswordFormLayout";

const PasswordFormLayout = styled(Card, { name: styledName })({
  "&": {
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    top: "50%",
    left: "50%",
    transform: `translate(-50%,-50%)`,
    width: "440px",
    height: "400px",
    borderRadius: "20px",
    padding: "25px 50px 30px 50px",
    backgroundColor: theme.palette.background.default,
  },
});

export default PasswordFormLayout;
